import { Link } from "react-router-dom";
import { Building2, TrendingUp, BarChart3, Download, LayoutGrid, ArrowRight, Inbox } from "lucide-react";
import { AdminShell } from "./AdminShell";

const TILES = [
  { label: "Projects", desc: "Manage the Recent Projects shown on the website", to: "/admin/projects", icon: Building2 },
  { label: "Opportunities", desc: "Manage investor opportunity listings on the website", to: "/admin/opportunities", icon: TrendingUp },
  { label: "Website Analytics", desc: "Traffic, page views and campaign attribution", to: "/admin/analytics", icon: BarChart3 },
  { label: "Resources", desc: "Add, edit and upload downloadable lead-magnet resources", to: "/crm/resources", icon: Download },
];

export default function AdminHome() {
  return (
    <AdminShell title="Website Admin">
      <div data-testid="admin-home-banner" className="bg-gradient-to-r from-[#0F2E23] to-[#123a2b] border border-brass/25 rounded-2xl p-6 mb-8 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-brass/15 shrink-0"><Inbox className="w-5 h-5 text-brass" /></span>
          <div>
            <h2 className="text-lg font-serif text-white">Lead management now lives in the CRM</h2>
            <p className="text-sm text-emerald-100/70 mt-1 max-w-xl">All enquiries, follow-ups and day-to-day contact management have moved to the CRM. This Admin area is for website content, resources and system settings.</p>
          </div>
        </div>
        <Link to="/crm/leads" data-testid="admin-go-leads" className="flex items-center gap-2 bg-brass hover:bg-brass-600 text-emerald-950 font-semibold rounded-full px-5 py-2.5 text-sm"><LayoutGrid className="w-4 h-4" /> Open Leads in CRM</Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} data-testid={`admin-tile-${t.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className="group flex items-center justify-between bg-[#0F2E23] border border-white/10 rounded-2xl p-5 hover:border-brass/50 transition-colors">
            <div className="flex items-center gap-4">
              <span className="grid place-items-center w-11 h-11 rounded-xl bg-white/5"><t.icon className="w-5 h-5 text-brass" /></span>
              <div><div className="text-white font-medium">{t.label}</div><div className="text-xs text-emerald-100/60 mt-0.5">{t.desc}</div></div>
            </div>
            <ArrowRight className="w-4 h-4 text-emerald-100/40 group-hover:text-brass group-hover:translate-x-0.5 transition" />
          </Link>
        ))}
      </div>
    </AdminShell>
  );
}
